import React, { useState, useCallback, useEffect, useRef } from 'react';
import * as XLSX from 'xlsx';
import CanvasDatagrid from 'canvas-datagrid';

import styled from "styled-components";

/* MODAL */
import { useModal } from 'hooks/modalContext';

export default function ExcelReader() {
  const { openModal } = useModal();

  const ExcelInput = useRef();

  const [data, setData] = useState([]);
  const [hasFile, setHasFile] = useState(false);
  const [hasSend, setHasSend] = useState(null);
  const gridRef = useRef(null);
  const containerRef = useRef(null);

  useEffect(() => {
    if (data.length > 0 && containerRef.current) {
      if (gridRef.current) {
        containerRef.current.innerHTML = '';
      }

      const grid = new CanvasDatagrid({
        parentNode: containerRef.current,
        data: data,
        style: {
          width: '100%',
        }
      });
      gridRef.current = grid;

      grid.style.width = '100%';

      grid.attributes.columnHeaderClickBehavior = 'sort';
      grid.attributes.allowColumnResize = true;
      grid.attributes.allowRowResize = true;
      grid.attributes.allowRowReorder = true;
      grid.attributes.allowColumnReorder = true;

      // 각 컬럼의 너비를 계산하는 함수
      const calculateColumnWidth = (data, columnKey) => {
        const context = document.createElement('canvas').getContext('2d');
        context.font = '16px Arial'; // 텍스트 스타일 설정
        let maxWidth = 50; // 기본 최소 너비

        data.forEach(row => {
          const text = String(row[columnKey] || ''); // 데이터가 없을 경우 빈 문자열 처리
          const width = context.measureText(text).width + 20; // 여백 추가
          maxWidth = Math.max(maxWidth, width);
        });

        return maxWidth;
      };

      // schema 업데이트: 컬럼 이름에 따른 너비 설정
      const schema = grid.schema.map(col => ({
        ...col,
        width: calculateColumnWidth(data, col.name), // 동적으로 계산된 너비 적용
      }));

      grid.schema = schema; // 새로운 schema 적용

    }
  }, [data])
  //
  // useDidMountEffect(() => {
  //   const contentsArr = [];
  //
  //   for(let i = 0; i < data.length; i++) {
  //     let objArr = [];
  //     for(let key in data[i]) {
  //       objArr.push(data[i][key]);
  //     }
  //     contentsArr.push(objArr);
  //   }
  //
  //   console.log('data:: ', data);
  //   console.log(contentsArr);
  // }, [data])

  const handleFileUpload = useCallback((e) => {
    const file = e.target.files?.[0];

    if (file) {
      setHasFile(true);
      const render = new FileReader();
      render.onload = (evt) => {
        const bstr = evt.target?.result;
        const wb = XLSX.read(bstr, {type: 'binary'});
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        const data = XLSX.utils.sheet_to_json(ws);
        setData(data);
        setHasSend(JSON.stringify(data, null, 2));
      };
      render.readAsBinaryString(file);
    }
  }, []);

  const handleSelect = item => {
    openModal({
      modalName: 'SelectExcelRead',
      modalData: {
        isRegi: false,
        data: {
          item: data,
          callback: {},
        },
      }
    });
  };

  const ResetFile = useCallback(() => {
    // Reset file input
    ExcelInput.current.value = '';

    // Reset states
    setData([]);
    setHasFile(false);
    setHasSend(null);

    // Complete grid reset
    if (containerRef.current) {
      // Remove the existing grid completely
      containerRef.current.innerHTML = '';

      // Remove grid reference
      gridRef.current = null;
    }
  }, []);

  useEffect(() => {
    // Only create grid when there is data and we're in file-loaded state
    if (data.length > 0 && hasFile && containerRef.current) {
      if (gridRef.current) {
        containerRef.current.innerHTML = '';
      }

      const grid = new CanvasDatagrid({
        parentNode: containerRef.current,
        data: data,
        style: {
          width: '100%',
        }
      });
      gridRef.current = grid;

      grid.style.width = '100%';
      grid.attributes.columnHeaderClickBehavior = 'sort';
      grid.attributes.allowColumnResize = true;
      grid.attributes.allowRowResize = true;
      grid.attributes.allowRowReorder = true;
      grid.attributes.allowColumnReorder = true;

      // Column width calculation logic remains the same
      const calculateColumnWidth = (data, columnKey) => {
        const context = document.createElement('canvas').getContext('2d');
        context.font = '16px Arial';
        let maxWidth = 50;

        data.forEach(row => {
          const text = String(row[columnKey] || '');
          const width = context.measureText(text).width + 20;
          maxWidth = Math.max(maxWidth, width);
        });

        return maxWidth;
      };

      const schema = grid.schema.map(col => ({
        ...col,
        width: calculateColumnWidth(data, col.name),
      }));

      grid.schema = schema;
    }
  }, [data, hasFile]);

  return (
    <>
      <Inner>
        <Title>
          <TitHead>
            <i/>
            <h4>Excel Reader</h4>
          </TitHead>

          <div className="btn-desc">
            <div className='action-btn'>
              <a href="https://ust-india.s3.ap-northeast-2.amazonaws.com/download/%E1%84%91%E1%85%A9%E1%84%92%E1%85%AC%E1%86%A8%E1%84%92%E1%85%A2%E1%84%8E%E1%85%AE%E1%86%BC_%E1%84%89%E1%85%A1%E1%84%92%E1%85%AE_%E1%84%8B%E1%85%A5%E1%86%B8%E1%84%85%E1%85%A9%E1%84%83%E1%85%B3_%E1%84%8B%E1%85%A3%E1%86%BC%E1%84%89%E1%85%B5%E1%86%A8.xlsx"
                 className='downBtn'
                 >Form Download</a>
            </div>
            <div className="upload">
              <label htmlFor='excel-read'>Read Excel</label>
              <input name='excel-read' id='excel-read' ref={ExcelInput} type='file' onChange={handleFileUpload}
                     accept=".xlsx, .xls, .csv"/>
            </div>
            {hasFile && (
                <div className='action-btn'>
                  <button className='sendBtn' onClick={handleSelect} disabled={!hasSend}>Data Send</button>
                  <button className='resetBtn' onClick={ResetFile} disabled={!hasSend}>Reset</button>
                </div>
            )}
          </div>
        </Title>
        <Content>

          {!hasFile ? (
            <div className="upload-notice">
              <div className="excel-desc">
                <span>Please Upload Your Excel</span>
                <p>Supported File Types : .xlsx, .xls, .csv</p>
              </div>
            </div>
          ) : (
            <div className="excel-view" ref={containerRef}/>
          )}
        </Content>
      </Inner>
    </>
  )
}

const Inner = styled.div`
  flex: 1;
  background: #ffffff;
`;

const Title = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;

  .btn-desc {
    display:flex;
    align-items:center;
    gap:0 16px;

    .upload {
      position:relative;
      display:flex;
      justify-content: flex-end;
      align-items: center;

      input {
        display:none;
      }

      label {
        display:block;
        padding:0 15px;
        width:95px;
        height:40px;
        line-height:40px;
        font-weight:400;
        font-size:14px;
        color:#ffffff;
        background:#0072B9;
      }
    }

    .action-btn {
      display:flex;
      align-items: center;
      gap:0 16px;
      
      .downBtn {
        display:block;
        padding:0 15px;
        width:125px;
        height:40px;
        line-height:40px;
        font-weight:400;
        font-size:14px;
        color:#000000;
        text-align:center;
        background:#FDFD96;
      }
      
      button {
        display:block;
        padding:0 15px;
        width:95px;
        height:40px;
        line-height:40px;
        font-weight:400;
        font-size:14px;
        color:#ffffff;
        text-align:center;
        
        &.sendBtn {
          background:#4CAF50;
        }

        &.resetBtn {
          background:#EB5757;
        }
      }
    }
  }
`;

const TitHead = styled.div`
  display: flex;
  align-items: center;
  gap: 0 10px;

  & i {
    display: block;
    width: 4px;
    height: 32px;
    border-radius: 0 2px 2px 0;
    background: #1e1e1e;
  }

  & h4 {
    font-weight: 500;
    font-size: 16px;
    color: #000000;
  }
`;

const Content = styled.div`
  margin-top: 35px;
  position: relative;
  height: 755px;
  
  .upload-notice {
    position:relative;
    width:100%;
    height:100%;
    display:flex;
    justify-content: center;
    align-items:center;
    background:#f8f8f8;

    .excel-desc {
      text-align:center;
      
      span {
        font-weight:700;
        font-size:32px;
        color:#111111;
      }
      
      p {
        margin-top:10px;
        display:block;
        font-weight:400;
        font-size:16px;
        color:#111111;
      }
    }
  }
  
  .excel-view {
    position:relative;
    height:100%;
    overflow-y:auto;
  }
`;
